export const getEmailSupport = (websiteId = window.config.websiteId) => {
  const EMAILS_SUPPORT = {
    1: "help@forthsupport.co.uk",
    2: "help@edgesupport.co.uk",
    3: "help@biomarkertracking.com",
  };

  const EMAILS_SUPPORT_NAME = {
    1: "Forth",
    2: "Edge",
    3: "Forth",
  };

  const emailAddressSupport = EMAILS_SUPPORT[websiteId] ?? "";
  const emailAddressName = EMAILS_SUPPORT_NAME[websiteId] ?? "";

  return {emailAddressSupport, emailAddressName};
};
